/*
 * NTC app.js — consent gating, pixel loaders, event tracking.
 *
 * Public surface:
 *   window.ntcOpenCookieSettings()  — re-opens the consent banner
 *
 * Pixels (GA4, Meta, TikTok, PostHog) load only after the user clicks
 * "Accept all". Choice is persisted in localStorage. The banner only
 * appears on first visit unless the user re-opens it via the footer.
 */
(function () {
  'use strict';

  var CONSENT_KEY = 'ntc_consent_v1';
  var config = window.ntcAnalytics || {};

  // ---------- Consent state ----------
  function getConsent() {
    try { return localStorage.getItem(CONSENT_KEY); } catch (e) { return null; }
  }

  function setConsent(value) {
    try { localStorage.setItem(CONSENT_KEY, value); } catch (e) { /* private mode */ }
  }

  function showBanner() {
    var banner = document.getElementById('ntc-consent-banner');
    if (banner) banner.hidden = false;
  }

  function hideBanner() {
    var banner = document.getElementById('ntc-consent-banner');
    if (banner) banner.hidden = true;
  }

  // ---------- Pixel loaders ----------
  function loadGA4(id) {
    if (!id) return;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id);
  }

  function loadMeta(id) {
    if (!id) return;
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }

  function loadTikTok(id) {
    if (!id) return;
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie'];
      ttq.setAndDefer = function (target, key) {
        target[key] = function () { target.push([key].concat(Array.prototype.slice.call(arguments, 0))); };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (key) {
        var inst = ttq._i[key] || [];
        for (var n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(inst, ttq.methods[n]);
        return inst;
      };
      ttq.load = function (e) {
        var url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = url;
        ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = {};
        var o = d.createElement('script'); o.type = 'text/javascript'; o.async = true;
        o.src = url + '?sdkid=' + e + '&lib=' + t;
        var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(o, a);
      };
      ttq.load(id);
      ttq.page();
    }(window, document, 'ttq');
  }

  function loadPostHog(key) {
    if (!key) return;
    !function (t, e) {
      var o, p, r;
      e.__SV ||
        (window.posthog = e,
        e._i = [],
        e.init = function (i, s, a) {
          function g(target, m) {
            var parts = m.split('.');
            if (parts.length === 2) { target = target[parts[0]]; m = parts[1]; }
            target[m] = function () { target.push([m].concat(Array.prototype.slice.call(arguments, 0))); };
          }
          (p = t.createElement('script')).type = 'text/javascript';
          p.async = true;
          p.src = s.api_host + '/static/array.js';
          r = t.getElementsByTagName('script')[0];
          r.parentNode.insertBefore(p, r);
          var u = e;
          if (a !== undefined) u = e[a] = []; else a = 'posthog';
          u.people = u.people || [];
          u.toString = function (x) { var name = 'posthog'; if (a !== 'posthog') name += '.' + a; if (!x) name += ' (stub)'; return name; };
          u.people.toString = function () { return u.toString(1) + '.people (stub)'; };
          o = 'capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId'.split(' ');
          for (var n = 0; n < o.length; n++) g(u, o[n]);
          e._i.push([i, s, a]);
        }, (e.__SV = 1));
    }(document, window.posthog || []);
    window.posthog.init(key, {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: true,
      autocapture: true,
      session_recording: { maskAllInputs: true }
    });
  }

  function loadPixels() {
    loadGA4(config.ga4);
    loadMeta(config.meta);
    loadTikTok(config.tiktok);
    loadPostHog(config.posthog);
  }

  // ---------- Event tracking ----------
  function track(eventName, properties) {
    properties = properties || {};
    if (window.gtag) window.gtag('event', eventName, properties);
    if (window.fbq) window.fbq('trackCustom', eventName, properties);
    if (window.ttq) window.ttq.track(eventName, properties);
    if (window.posthog) window.posthog.capture(eventName, properties);
  }

  function setupTracking() {
    // counter_view — IntersectionObserver on the first visible counter
    var counter = document.querySelector('[data-ntc-counter]');
    if (counter && 'IntersectionObserver' in window) {
      var counterObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            track('counter_view');
            counterObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      counterObs.observe(counter);
    }

    // form_view — observe any container that holds a Shopify Forms embed
    var forms = document.querySelectorAll('shopify-forms, form[action*="customers"], [class*="shopify-forms"]');
    if (forms.length && 'IntersectionObserver' in window) {
      var formObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            track('form_view');
            formObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      forms.forEach(function (f) { formObs.observe(f); });
    }

    // form_submit_attempt — best-effort listener
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (form.matches('form[action*="customers"], shopify-forms form, form')) {
        track('form_submit_attempt');
      }
    }, true);

    // cta_click_final — click on the final-cta button
    var finalCta = document.querySelector('[data-ntc-section="final-cta"] .ntc-btn');
    if (finalCta) {
      finalCta.addEventListener('click', function () {
        track('cta_click_final');
      });
    }
  }

  // ---------- Banner wiring ----------
  function wireBanner() {
    var banner = document.getElementById('ntc-consent-banner');
    if (!banner) return;
    banner.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-ntc-consent]');
      if (!btn) return;
      var choice = btn.getAttribute('data-ntc-consent');
      setConsent(choice);
      hideBanner();
      if (choice === 'all') loadPixels();
    });
  }

  // ---------- Public API ----------
  window.ntcOpenCookieSettings = function () {
    showBanner();
  };

  // ---------- Init ----------
  function init() {
    wireBanner();
    setupTracking();

    if (!config.hasAnyPixel) return; // No pixels configured; nothing to gate.

    var consent = getConsent();
    if (consent === 'all') {
      loadPixels();
    } else if (!consent) {
      showBanner();
    }
    // 'essential' = no pixels, no banner.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
